import { Allotment } from 'allotment';
import 'allotment/dist/style.css';
import Style from './assets/styles.scss';
import { ISplitPaneProps } from './entities';

const BCSplitPane = (props: ISplitPaneProps) => {
	return (
		<Allotment
			vertical={props.vertical}
			defaultSizes={props.defaultSizes}
			onDragEnd={props.onDragEnd}
			onDragStart={props.onDragStart}
			onReset={props.onReset}
			onVisibleChange={props.onVisibleChange}
			minSize={props.minSize}
			maxSize={props.maxSize}
			onChange={props.onChange}
			snap={props.snap}
			separator={props.separator}
			proportionalLayout={props.proportionalLayout}
			className={Style.Resizer}
		>
			{props.children}
		</Allotment>
	);
};

export default BCSplitPane;
export { ISplitPaneProps };
